import React from 'react';
import { useFoodTemperature } from '../context/FoodTemperatureContext';

export default function CheckSummaryCard() {
  // Data Breakdown
  const { stats } = useFoodTemperature();
  const totalItems = stats.total;
  const percentage = count => totalItems ? count / totalItems * 100 : 0;
  const withinPercent = percentage(stats.withinRange);
  const outPercent = percentage(stats.outOfRange);
  const unassessedPercent = percentage(stats.unassessed);
  const categories = [
    { label: 'Within Range', count: stats.withinRange, percentage: `${Math.round(withinPercent)}%`, dotColor: 'bg-emerald-500' },
    { label: 'Out of Range', count: stats.outOfRange, percentage: `${Math.round(outPercent)}%`, dotColor: 'bg-rose-500' },
    { label: 'Not recorded', count: stats.unassessed, percentage: `${Math.round(unassessedPercent)}%`, dotColor: 'bg-amber-400' },
  ];

  return (
    <div className="w-full col-span-3 max-w-[280px] m-auto bg-white border border-gray-100 rounded-2xl p-5 shadow-sm">
      {/* Title */}
      <h3 className="text-sm font-bold text-gray-900 mb-6">
        Check Summary
      </h3>

      {/* SVG Donut Chart Visual */}
      <div className="relative flex items-center justify-center w-36 h-36 mx-auto mb-6">
        <svg className="w-full h-full transform -rotate-90" viewBox="0 0 36 36">
          {/* Gray Track Base */}
          <circle
            cx="18"
            cy="18"
            r="15.915"
            fill="none"
            stroke="#e2e8f0"
            strokeWidth="2.5"
          />
          {/* Within Range Segment (47%) */}
          <circle
            cx="18"
            cy="18"
            r="15.915"
            fill="none"
            stroke="#10b981"
            strokeWidth="2.5"
            strokeDasharray={`${withinPercent} 100`}
            strokeDashoffset="0"
          />
          {/* Out of Range Segment (7%) */}
          <circle
            cx="18"
            cy="18"
            r="15.915"
            fill="none"
            stroke="#f43f5e"
            strokeWidth="2.5"
            strokeDasharray={`${outPercent} 100`}
            strokeDashoffset={-withinPercent}
          />
          {/* Pending Segment (47%) */}
          <circle
            cx="18"
            cy="18"
            r="15.915"
            fill="none"
            stroke="#fbbf24"
            strokeWidth="2.5"
            strokeDasharray={`${unassessedPercent} 100`}
            strokeDashoffset={-(withinPercent + outPercent)}
          />
        </svg>

        {/* Center Label Context */}
        <div className="absolute text-center">
          <span className="block text-2xl font-black text-gray-900 leading-none">
            {totalItems}
          </span>
          <span className="text-[10px] font-bold text-gray-400 block mt-1 tracking-wide">
            Total Items
          </span>
        </div>
      </div>

      {/* Metric Breakdown Rows List */}
      <div className="flex flex-col gap-3.5">
        {categories.map((item, idx) => (
          <div key={idx} className="flex items-center justify-between text-xs">
            {/* Left Status Label */}
            <div className="flex items-center gap-2">
              <span className={`w-2 h-2 rounded-full shrink-0 ${item.dotColor}`} />
              <span className="font-semibold text-gray-500">
                {item.label}
              </span>
            </div>
            {/* Right Value Metrics */}
            <span className="font-bold text-gray-800 tracking-tight">
              {item.count} <span className="font-medium text-gray-400 ml-0.5">({item.percentage})</span>
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
